import jQuery from 'jquery';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import './dynamicModal';
import * as Utility from './utility.js';

(function ($) {
    // =====================================================
    // CONFIG
    // =====================================================
    mapboxgl.accessToken = window.mapboxToken; // set in Razor/Layout

    const DEFAULT_CENTER = [-114.06666, 51.049999]; // Calgary
    const DEFAULT_ZOOM = 9;
    const FLY_TO_ZOOM = 9;
    const MIN_ZOOM = 8;

    // =====================================================
    // STATE
    // =====================================================
    let SAASAPP_Map = null;
    let SAASAPP_ArrayOfMapMarkers = [];
    let shouldTriggerIdealEvent = false;

    // =====================================================
    // INIT
    // =====================================================
    bindShareButtons();
    bindSearchFilterControls();
    bindMoreFiltersDropdownCloseEvent();

    document.addEventListener('searchfilterchange', function (event) {
        const detail = event.detail;

        if (detail.shouldUpdateMap === true) {
            if (
                detail.additionalData &&
                detail.additionalData.listOfRecords &&
                detail.additionalData.listOfRecords.length > 0
            ) {
                setMarkersFromMapData(detail.additionalData.listOfRecords);
            } else {
                clearExistingMapMarkers();
            }
        }
    });

    if ($('.appssr .page-link').length > 0) {
        console.log('[appssr .page-link]');
        $('.appssr .page-link').on('click', function (e) {
            e.preventDefault();
            console.log('[page-link] [click]');
            let filterValues = getAllSelectedFilterValues();
            filterValues['PageIndex'] = this.dataset.pindex;
            console.log(filterValues);
            let selectedCity = document.getElementById('SelectCity').value;
            processFilterChange(filterValues, selectedCity, true);
        });
    }

    // =====================================================
    // MAP INIT
    // =====================================================
    function initMap() {
        console.log('Initializing map');
        SAASAPP_Map = new mapboxgl.Map({
            container: 'mapcontainer',
            style: 'mapbox://styles/mapbox/streets-v12',
            center: DEFAULT_CENTER,
            zoom: DEFAULT_ZOOM,
            minZoom: MIN_ZOOM,
        });

        SAASAPP_Map.addControl(new mapboxgl.NavigationControl(), 'top-right');

        SAASAPP_Map.on('moveend', function () {
            console.log('[mapbox] [moveend] ' + shouldTriggerIdealEvent);
            try {
                const bounds = SAASAPP_Map.getBounds();

                const range = [
                    bounds.getEast(),
                    bounds.getWest(),
                    bounds.getSouth(),
                    bounds.getNorth(),
                ];

                if (!!shouldTriggerIdealEvent) {
                    triggerFilterChangeOnMapBoundChange(range);
                }

                shouldTriggerIdealEvent = true;
            } catch (err) {
                console.log(err);
            }
        });

        SAASAPP_Map.on('load', function () {
            setMarkersFromMapData(window.mapData || []);
        });
    }

    // =====================================================
    // MARKERS
    // =====================================================
    function setMarkersFromMapData(mapData) {
        clearExistingMapMarkers();
        console.log('Setting map markers with data:', mapData);
        if (!mapData || mapData.length === 0) return;

        const grouped = {};

        mapData.forEach((item) => {
            console.log('Processing item for marker:', item);
            if (!item.latitude || !item.longitude) return;

            const key = item.latitude + '__' + item.longitude;

            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(item);
        });

        let firstCenter = null;
        let arrayOfLngLats = [];

        Object.keys(grouped).forEach((key) => {
            const list = grouped[key];
            const item = list[0];

            const lng = Number(item.longitude);
            const lat = Number(item.latitude);

            arrayOfLngLats.push({ lng, lat });

            if (!firstCenter) {
                firstCenter = [lng, lat];
            }

            const markerElement = document.createElement('div');
            markerElement.className = 'saasapp-marker';

            const popup = new mapboxgl.Popup({
                offset: 20,
                maxWidth: '200px',
            }).setHTML(getCardHtmlForListOfProperties(list));

            popup.on('open', function () {
                bindPopupCardEvents();
            });

            const marker = new mapboxgl.Marker(markerElement)
                .setLngLat([lng, lat])
                .setPopup(popup)
                .addTo(SAASAPP_Map);

            SAASAPP_ArrayOfMapMarkers.push(marker);
        });
        let center = getCenterBasedOnArrayOfLngLat(arrayOfLngLats);
        if (center) {
            SAASAPP_Map.flyTo({
                center: center,
                zoom: FLY_TO_ZOOM,
            });
        }
    }

    function getCenterBasedOnArrayOfLngLat(coords) {
        const total = coords.reduce(
            (acc, cur) => {
                acc.lng += cur.lng;
                acc.lat += cur.lat;
                return acc;
            },
            { lng: 0, lat: 0 }
        );

        return {
            lng: total.lng / coords.length,
            lat: total.lat / coords.length,
        };
    }

    function clearExistingMapMarkers() {
        SAASAPP_ArrayOfMapMarkers.forEach((marker) => marker.remove());
        SAASAPP_ArrayOfMapMarkers = [];
    }

    // =====================================================
    // MAP FILTER BOUNDS
    // =====================================================
    function triggerFilterChangeOnMapBoundChange(range) {
        const selectedCity = $('#SelectCity').val();

        setLatLngRange(range.join(','));

        const filterValues = getAllSelectedFilterValues();

        processFilterChange(filterValues, selectedCity, true);
    }

    function setLatLngRange(value) {
        const el = document.getElementById('mapcontainer');

        if (!el) return;

        el.dataset.latlngRange = value || '';
    }

    // =====================================================
    // SEARCH FILTERS
    // =====================================================
    function bindSearchFilterControls() {
        $('#resetSearchFilters').on('click', function (e) {
            e.preventDefault();
            console.log('[resetSearchFilters] [click]');
            reloadPageWithCity();
        });
        $('#toggleFilters').on('click', function (e) {
            e.preventDefault();
            console.log('[toggleFilters] [click]');
            $('.search-result-filters__controls').toggleClass('d-none');
        });
        $('#toggleListOnly,#toggleMapOnly').on('click', function (e) {
            console.log('[toggleListOnly]');
            console.log(e.currentTarget.id);
            console.log(e.currentTarget.dataset.target);
            let targetElementSelector = e.currentTarget.dataset.target;
            if (!$(targetElementSelector).hasClass('d-block')) {
                $(targetElementSelector).addClass('d-block');
            }
            if ($(targetElementSelector).hasClass('d-none')) {
                $(targetElementSelector).removeClass('d-none');
            }
            if (e.currentTarget.id == 'toggleListOnly') {
                hideOtherListingSection('toggleMapOnly');
            } else {
                hideOtherListingSection('toggleListOnly');
            }
        });
        if ($('.search-result-filters').length > 0) {
            let filterValues = {};
            let selectedCity = document.getElementById('SelectCity').value;
            $('.search-result-filters select').on('change', function () {
                filterValues = getAllSelectedFilterValues();
                processFilterChange(filterValues, selectedCity);
            });
            $("#dropdownMenuMoreFiltersOptionsWrapper input[name='checkboxMoreFilters']").on(
                'change',
                function () {
                    if ($(this).val() !== 'All') {
                        // option other then "All" is selected
                        resetCheckboxAll();
                    } else {
                        // option "All" is selected
                        toggleMoreFiltersCheckboxes($(this).is(':checked'));
                    }
                }
            );
        }
    }

    function hideOtherListingSection(otherElementId) {
        let btnElement = document.getElementById(otherElementId);
        if (btnElement) {
            let otherElementSelector = btnElement.dataset.target;
            $(otherElementSelector).addClass('d-none');
        }
    }
    function toggleMoreFiltersCheckboxes(shouldCheck) {
        $('#checkboxMoreFilters2').prop('checked', shouldCheck);
        $('#checkboxMoreFilters3').prop('checked', shouldCheck);
        $('#checkboxMoreFilters4').prop('checked', shouldCheck);
        $('#checkboxMoreFilters5').prop('checked', shouldCheck);
    }
    function resetCheckboxAll() {
        let allValues = ['0', '1', '2', '3'];
        let selectedValues = [];
        $("#dropdownMenuMoreFiltersOptionsWrapper input[name='checkboxMoreFilters']").each(
            function () {
                const isChecked = $(this).is(':checked');
                if (isChecked && $(this).val() !== 'All') {
                    selectedValues.push($(this).val());
                }
            }
        );
    }

    function bindMoreFiltersDropdownCloseEvent() {
        var dropdownMenuMoreFiltersMenuElement = document.getElementById(
            'dropdownMenuMoreFiltersMenu'
        );
        if (dropdownMenuMoreFiltersMenuElement) {
            dropdownMenuMoreFiltersMenuElement.addEventListener('hide.bs.dropdown', function () {
                console.log('[bindMoreFiltersDropdownCloseEvent]');
                let filterValues = getAllSelectedFilterValues();
                setTextOnMoreFiltersDropdown(filterValues);
                processFilterChange(filterValues, document.getElementById('SelectCity').value);
            });
        }
    }
    function setTextOnMoreFiltersDropdown(filteredValues) {
        let dropdownMenuMoreFiltersMenuElement = document.getElementById(
            'dropdownMenuMoreFiltersMenu'
        );
        if (dropdownMenuMoreFiltersMenuElement) {
            let newText = 'More Filters';
            if (filteredValues && filteredValues['SelectMoreFilters']) {
                let selectedValue = filteredValues['SelectMoreFilters'];
                if (selectedValue) {
                    let selectedItemsCount = selectedValue.split(',').length;
                    if (selectedItemsCount > 0) {
                        newText = selectedItemsCount + ' selected';
                    }
                }
            }
            dropdownMenuMoreFiltersMenuElement.innerHTML = newText;
        }
    }

    function getAllSelectedFilterValues() {
        let filterValues = {};
        $('.search-result-filters select').each(function () {
            let currentElementValue = $(this).val();
            let currentElementName = $(this).attr('name');
            if (currentElementValue !== undefined) {
                console.log(
                    '[currentElementName]' + currentElementName + ' => ' + currentElementValue
                );
                if (currentElementName === 'SelectListingStatus' && currentElementValue != '') {
                    currentElementValue = $('#SelectListingStatus option:selected').text();
                }
                filterValues[currentElementName] = currentElementValue;
            } else {
                filterValues[currentElementName] = '';
            }
        });
        let moreFiltersValues = [];
        $('#SelectMoreFilters input[name="checkboxMoreFilters"]:checked').each(function () {
            console.log('[SelectMoreFilters] input[name="checkboxMoreFilters"]:checked');
            console.log(this.value);
            if (this.value && this.value !== 'open-now') {
                moreFiltersValues.push(this.value);
            } else if (this.value && this.value === 'open-now') {
                filterValues['IsOpenNow'] = 'true';
            }
        });
        if (moreFiltersValues && moreFiltersValues.length > 0) {
            filterValues['SelectMoreFilters'] = moreFiltersValues.join(',');
        } else {
            filterValues['SelectMoreFilters'] = '';
        }
        let googlemapElement = document.getElementById('mapcontainer');
        if (
            googlemapElement &&
            googlemapElement.dataset &&
            googlemapElement.dataset.latlngRange &&
            googlemapElement.dataset.latlngRange != ''
        ) {
            filterValues['SelectLatLng'] = googlemapElement.dataset.latlngRange;
        } else {
            filterValues['SelectLatLng'] = '';
        }
        // NOTE: if want to reset page number on search filter. try to add following
        // filterValues['PageIndex'] = 0;
        return filterValues;
    }

    function processFilterChange(filterValues, originalSelectedCity, isTriggerSourceMap) {
        if (
            originalSelectedCity &&
            filterValues['SelectCity'] &&
            filterValues['SelectCity'] !== originalSelectedCity
        ) {
            window.location.href = Utility.getAbsolutePath(
                '/discover/' + filterValues['SelectCity']
            );

            return;
        }

        document.getElementById('razorapp').innerHTML = '';
        let eventData = { url: window.location.href, filters: filterValues };
        let searchParams = [];

        if (filterValues['SelectCategory'] && filterValues['SelectCategory'] !== '') {
            searchParams.push('categories=' + filterValues['SelectCategory']);
        }
        if (filterValues['SelectSort'] && filterValues['SelectSort'] !== '') {
            searchParams.push('sort=' + filterValues['SelectSort']);
        }
        if (filterValues['SelectMoreFilters'] && filterValues['SelectMoreFilters'] !== '') {
            searchParams.push('morefilters=' + filterValues['SelectMoreFilters']);
        }
        if (filterValues['IsOpenNow'] && filterValues['IsOpenNow'] === 'true') {
            searchParams.push('isopen=true');
        }
        if (filterValues['SelectLatLng'] && filterValues['SelectLatLng'] !== '') {
            let encodedLatLng = encodeURIComponent(filterValues['SelectLatLng']);
            searchParams.push('latlngrange=' + encodedLatLng);
        }
        let currentPage = 1;
        if (filterValues['PageIndex'] && filterValues['PageIndex'] !== '') {
            searchParams.push('page=' + parseFloat(filterValues['PageIndex']));
            currentPage = parseFloat(filterValues['PageIndex']);
        }

        let searchUrl = getSearchurlByEndpointAndParams(
            '/api/search/' + originalSelectedCity,
            searchParams
        );

        fetch(searchUrl) // Call the fetch function passing the url of the API as a parameter
            .then((res) => res.json())
            .then(function (res) {
                console.log('[fetch][currentPage]' + currentPage);
                eventData.additionalData = res;
                eventData.currentPage = currentPage;
                eventData.shouldUpdateMap =
                    isTriggerSourceMap && isTriggerSourceMap == true ? false : true;
                const cevent = new CustomEvent('searchfilterchange', { detail: eventData });
                document.dispatchEvent(cevent);
            })
            .catch(function (err) {
                console.log('[CATCH] err');
                console.log(err);
            });
    }

    function getSearchurlByEndpointAndParams(url, arrayOfParams) {
        if (arrayOfParams && arrayOfParams.length > 0) {
            return url + '?' + arrayOfParams.join('&');
        }
        return url;
    }

    function reloadPageWithCity() {
        const city = $('#SelectCity').val();

        if (city) {
            window.location.href = Utility.getAbsolutePath('/discover/' + city);
        } else {
            location.reload();
        }
    }

    // =====================================================
    // POPUP EVENTS
    // =====================================================
    function bindPopupCardEvents() {
        $('.map-card-container')
            .off('click')
            .on('click', function () {
                const url = $(this).data('url');

                if (url) {
                    window.open(url, '_blank', 'noopener,noreferrer');
                }
            });

        $('.saasapp-card-slider-btn')
            .off('click')
            .on('click', function (e) {
                e.stopPropagation();

                const action = this.dataset.action;
                const ul = this.parentElement.previousElementSibling;

                const active = ul.querySelector('.active');

                active.classList.remove('active');

                let next;

                if (action === 'next') {
                    next = active.nextElementSibling;
                    if (!next) next = ul.firstElementChild;
                } else {
                    next = active.previousElementSibling;
                    if (!next) next = ul.lastElementChild;
                }

                next.classList.add('active');

                const slides = ul.querySelectorAll('li');

                const index = Array.from(slides).indexOf(next) + 1;

                this.parentElement.querySelector('.saasapp-card-slider-count').innerHTML =
                    index + ' of ' + slides.length;
            });
    }

    // =====================================================
    // SHARE
    // =====================================================
    function bindShareButtons() {
        $('.share-link').on('click', function () {
            const title = $(this).attr('title');
            const link = Utility.getAbsolutePath(this.dataset.link);

            if (navigator.share) {
                navigator.share({
                    title,
                    text: link,
                    url: link,
                });
            } else {
                navigator.clipboard.writeText(link);
                alert('Link copied.');
            }
        });
    }

    // =====================================================
    // HTML BUILDERS
    // =====================================================
    function getCardHtmlForListOfProperties(items) {
        let html = '';

        items.forEach((item, index) => {
            html += `
                <li class="saasapp-card-slider-li ${index === 0 ? 'active' : ''}">
                    ${getBusinessDataCardHtml(item)}
                </li>
            `;
        });

        return `
            <div class="saasapp-card-slider-container">
                <ul class="saasapp-card-slider-ul list-unstyled m-0 p-0">
                    ${html}
                </ul>

                ${
                    items.length > 1
                        ? `
                    <div class="saasapp-card-slider-btns d-flex justify-content-between">
                        <button data-action="prev" class="saasapp-card-slider-btn btn">‹</button>
                        <div class="saasapp-card-slider-count">1 of ${items.length}</div>
                        <button data-action="next" class="saasapp-card-slider-btn btn">›</button>
                    </div>`
                        : ''
                }
            </div>
        `;
    }

    function generateStars(rating) {
        console.log('[generateStars] rating: ' + rating);
        let formattedRating = '';
        if (rating) {
            formattedRating = parseFloat(rating.toFixed(1));
        }
        let stars = '<span class="fw-semibold me-1">' + formattedRating + '</span>';

        for (let i = 1; i <= 5; i++) {
            if (i <= rating) stars += '<span class="text-warning">★</span>';
            else stars += '<span class="text-secondary">☆</span>';
        }

        return stars;
    }

    function getBusinessDataCardHtml(item) {
        const img = item.firstMediaFileReadModel
            ? item.firstMediaFileReadModel.mediaFileImagePath
            : '/assets/images/saasapp_placeholder_more_photos_coming_soon.webp';
        const isPlaceholderImage = item.firstMediaFileReadModel ? false : true;
        const imgClass = isPlaceholderImage
            ? 'img-fluid mxh-20 placeholder-image'
            : 'img-fluid mxh-20';
        const starRatingHtml = generateStars(item.googleReviewRating);
        const googleReviewTotalCount = item.googleReviewTotalCount
            ? item.googleReviewTotalCount
            : '0';
        let tagHtml = '';
        if (item.listOfTags && item.listOfTags.length > 0) {
            tagHtml = `<div class="d-flex flex-wrap align-items-center text-muted">
                                    <i class="bi bi-tags me-1"></i>`;
            tagHtml += item.listOfTags
                .map(
                    (tag, index) =>
                        `<span class="badge bg-light me-1 text-dark fw-light" key=${index}>
                    ${tag}
                </span>`
                )
                .join('');
            tagHtml += `</div>`;
        }
        let streetAddressHtml = '';
        if (!item.hideAddress && item.streetAddress) {
            streetAddressHtml = `<div class="small text-muted">${item.streetAddress}</div>`;
        }
        return `
            <div data-url="/Listings/View/${item.idWithSlug}" class="map-card-container cursor-pointer">
                <div class="card border-0">
                    <img src="${img}" class="${imgClass}" />
                    <div class="card-body p-0 pt-2">
                        <h6 class="small mb-1 text-truncate">${item.title}</h6>
                        <div class="row">
                        <div class="col text-truncate text-muted">
                                    <div class="small google-rating">
                                        <span>${starRatingHtml}</span>
                                        <span>(${googleReviewTotalCount})</span>
                                    </div>
                                </div>
                        </div>
                        <div class="d-flex flex-wrap align-items-center text-muted">
                            <i class="bi bi-ui-checks-grid me-1"></i>
                            <span class="me-1">${item.categoryName}</span>
                        </div>
                        ${tagHtml}
                        ${streetAddressHtml}
                        <div class="small">${item.cityName}</div>
                    </div>
                </div>
            </div>
        `;
    }

    // =====================================================
    // GLOBAL
    // =====================================================
    window.initMap = initMap;
})(jQuery);
